import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=24c3581c&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=ts"
export * from "./MainHeader.vue?vue&type=script&lang=ts"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=24c3581c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c3581c",
  null
  
)

export default component.exports